export const defaultData = [
  {
    "id": 18,
    "date": "2023-10-04T22:15:50",
    "date_gmt": "2023-10-05T01:15:50",
    "guid": {
      "rendered": "https://rlimaadv.com.br/blog/?p=18"
    },
    "modified": "2023-10-04T22:45:14",
    "modified_gmt": "2023-10-05T01:45:14",
    "slug": "a-importancia-da-esg-rumo-a-um-futuro-sustentavel-no-brasil",
    "status": "publish",
    "type": "post",
    "link": "https://rlimaadv.com.br/blog/a-importancia-da-esg-rumo-a-um-futuro-sustentavel-no-brasil/",
    "title": {
      "rendered": "A Importância da ESG: Rumo a um Futuro Sustentável no Brasil"
    },
    "content": {
      "rendered": "\n<p>O mundo está em constante transformação, e à medida que enfrentamos desafios globais como as mudanças climáticas, a desigualdade social e a busca por práticas de governança mais transparentes e éticas, a sigla ESG tornou-se cada vez mais relevante. Mas o que é ESG, e por que isso importa tanto para o Brasil?</p>\n\n\n\n<p><strong>O Que é ESG?</strong></p>\n\n\n\n<p>ESG é uma sigla que representa três pilares fundamentais para avaliar o desempenho sustentável de uma empresa ou organização. Esses pilares são:</p>\n\n\n\n<ol>\n<li><strong>Ambiental (E &#8211; Environmental)</strong>: Refere-se às práticas e políticas relacionadas ao meio ambiente. Isso inclui a gestão de recursos naturais, redução de emissões de carbono, conservação da biodiversidade e eficiência energética. No Brasil, onde a Amazônia desempenha um papel vital na saúde global do planeta, a dimensão ambiental do ESG é de extrema importância.</li>\n\n\n\n<li><strong>Social (S &#8211; Social)</strong>: Diz respeito ao impacto que a empresa tem na sociedade em que opera. Isso engloba a igualdade de oportunidades, diversidade, segurança no local de trabalho, bem-estar dos funcionários e a relação com as comunidades locais. Em um país como o Brasil, com desafios sociais significativos, a dimensão social do ESG é crucial para promover mudanças positivas.</li>\n\n\n\n<li><strong>Governança (G &#8211; Governance)</strong>: Envolve a forma como uma empresa é gerenciada e supervisionada. Isso abrange questões como transparência, ética nos negócios, estrutura de liderança e prestação de contas. Melhorar a governança é um passo essencial para combater a corrupção e criar um ambiente de negócios confiável.</li>\n</ol>\n\n\n\n<p><strong>Por que ESG é Importante para o Brasil?</strong></p>\n\n\n\n<p>O Brasil é um país rico em recursos naturais, diversidade cultural e potencial econômico. No entanto, enfrenta desafios significativos, como o desmatamento na Amazônia, altos níveis de desigualdade, questões de governança e a necessidade de atrair investimentos sustentáveis.</p>\n\n\n\n<ol>\n<li><strong>Preservação da Amazônia</strong>: A dimensão ambiental do ESG é especialmente crucial para o Brasil, já que o país abriga a maior parte da Floresta Amazônica. A preservação deste ecossistema é fundamental para a estabilidade climática global. Empresas brasileiras que adotam práticas sustentáveis de gestão ambiental contribuem para a conservação da Amazônia e para a redução das emissões de carbono.</li>\n\n\n\n<li><strong>Inclusão Social</strong>: A dimensão social do ESG também desempenha um papel vital no Brasil. O país enfrenta desafios de desigualdade de renda, acesso à educação e oportunidades de emprego. Empresas que investem em programas de inclusão, diversidade e responsabilidade social estão ajudando a construir uma sociedade mais equitativa.</li>\n\n\n\n<li><strong>Melhoria na Governança</strong>: A melhoria na governança é essencial para atrair investimentos e promover o crescimento econômico sustentável. Empresas que adotam políticas de governança transparentes e éticas têm mais probabilidade de atrair investidores e se destacar no mercado global.</li>\n</ol>\n\n\n\n<p><strong>Os Benefícios da ESG para Empresas Brasileiras</strong></p>\n\n\n\n<p>A adoção de práticas ESG não apenas contribui para um futuro mais sustentável para o Brasil, mas também oferece vantagens significativas para as empresas locais:</p>\n\n\n\n<ol>\n<li><strong>Acesso a Investimentos Sustentáveis</strong>: Investidores globais estão cada vez mais direcionando seus recursos para empresas com sólidos critérios ESG. Empresas brasileiras que adotam essas práticas podem acessar um amplo pool de investidores e fundos focados em sustentabilidade.</li>\n\n\n\n<li><strong>Reputação e Marca Fortalecidas</strong>: Empresas que se comprometem com o ESG geralmente desfrutam de uma reputação mais forte e uma marca mais confiável. Isso pode atrair mais clientes e melhorar a fidelidade à marca.</li>\n\n\n\n<li><strong>Gerenciamento de Riscos Aprimorado</strong>: A gestão de riscos é uma parte integral do ESG. Empresas que consideram cuidadosamente os aspectos ambientais, sociais e de governança estão melhor preparadas para enfrentar desafios futuros e eventos inesperados.</li>\n\n\n\n<li><strong>Atração e Retenção de Talentos</strong>: Funcionários estão cada vez mais interessados em trabalhar para empresas alinhadas com valores éticos e sustentáveis. As empresas que adotam práticas ESG podem atrair e reter talentos de alto nível.</li>\n</ol>\n\n\n\n<p><strong>O Futuro do ESG no Brasil</strong></p>\n\n\n\n<p>À medida que o mundo avança em direção a um futuro mais sustentável, o Brasil tem a oportunidade de liderar essa transformação. Empresas, organizações governamentais e a sociedade civil podem colaborar para promover o ESG e fazer avançar a agenda da sustentabilidade.</p>\n\n\n\n<p>É importante que as empresas brasileiras considerem não apenas os benefícios de curto prazo, mas também o impacto a longo prazo que suas ações podem ter na sociedade e no meio ambiente. A adoção de práticas ESG não é apenas uma escolha ética, mas também uma estratégia inteligente para o sucesso futuro.</p>\n\n\n\n<p>Em resumo, o ESG desempenha um papel fundamental na construção de um Brasil mais sustentável, equitativo e ético. À medida que o país abraça esses princípios, ele pode se tornar um exemplo global de como empresas e governos podem trabalhar juntos para criar um futuro melhor para todos.</p>\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "<p>O mundo está em constante transformação, e à medida que enfrentamos desafios globais como as mudanças climáticas, a desigualdade social e a busca por práticas de governança mais transparentes e éticas, a sigla ESG tornou-se cada vez mais relevante. Mas o que é ESG, e por que isso importa tanto para o Brasil? O Que [&hellip;]</p>\n",
      "protected": false
    },
    "author": 1,
    "featured_media": 22,
    "comment_status": "open",
    "ping_status": "open",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "footnotes": ""
    },
    "categories": [
      1
    ],
    "tags": [],
    "better_featured_image": {
      "id": 22,
      "alt_text": "",
      "caption": "",
      "description": "",
      "media_type": "image",
      "media_details": {
        "width": 2560,
        "height": 1707,
        "file": "2023/10/front-view-man-with-wooden-blocks-scaled.jpg",
        "filesize": 305049,
        "sizes": {
          "medium": {
            "file": "front-view-man-with-wooden-blocks-300x200.jpg",
            "width": 300,
            "height": 200,
            "mime-type": "image/jpeg",
            "filesize": 12648,
            "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/front-view-man-with-wooden-blocks-300x200.jpg"
          },
          "large": {
            "file": "front-view-man-with-wooden-blocks-1024x683.jpg",
            "width": 1024,
            "height": 683,
            "mime-type": "image/jpeg",
            "filesize": 74479,
            "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/front-view-man-with-wooden-blocks-1024x683.jpg"
          },
          "thumbnail": {
            "file": "front-view-man-with-wooden-blocks-150x150.jpg",
            "width": 150,
            "height": 150,
            "mime-type": "image/jpeg",
            "filesize": 5974,
            "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/front-view-man-with-wooden-blocks-150x150.jpg"
          },
          "medium_large": {
            "file": "front-view-man-with-wooden-blocks-768x512.jpg",
            "width": 768,
            "height": 512,
            "mime-type": "image/jpeg",
            "filesize": 48379,
            "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/front-view-man-with-wooden-blocks-768x512.jpg"
          },
          "1536x1536": {
            "file": "front-view-man-with-wooden-blocks-1536x1024.jpg",
            "width": 1536,
            "height": 1024,
            "mime-type": "image/jpeg",
            "filesize": 135711,
            "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/front-view-man-with-wooden-blocks-1536x1024.jpg"
          },
          "2048x2048": {
            "file": "front-view-man-with-wooden-blocks-2048x1365.jpg",
            "width": 2048,
            "height": 1365,
            "mime-type": "image/jpeg",
            "filesize": 213482,
            "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/front-view-man-with-wooden-blocks-2048x1365.jpg"
          }
        },
        "image_meta": {
          "aperture": "8",
          "credit": "",
          "camera": "Canon EOS RP",
          "caption": "",
          "created_timestamp": "1675196320",
          "copyright": "",
          "focal_length": "100",
          "iso": "100",
          "shutter_speed": "0.008",
          "title": "",
          "orientation": "1",
          "keywords": []
        },
        "original_image": "front-view-man-with-wooden-blocks.jpg"
      },
      "post": 18,
      "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/front-view-man-with-wooden-blocks-scaled.jpg"
    },
    "_links": {
      "self": [
        {
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/posts/18"
        }
      ],
      "collection": [
        {
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/users/1"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/comments?post=18"
        }
      ],
      "version-history": [
        {
          "count": 4,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/posts/18/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 24,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/posts/18/revisions/24"
        }
      ],
      "wp:featuredmedia": [
        {
          "embeddable": true,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/media/22"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/media?parent=18"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/categories?post=18"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/tags?post=18"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    },
    "_embedded": {
      "author": [
        {
          "id": 1,
          "name": "rlima_admin",
          "url": "https://rlimaadv.com.br/blog",
          "description": "",
          "link": "https://rlimaadv.com.br/blog/author/rlima_admin/",
          "slug": "rlima_admin",
          "avatar_urls": {
            "24": "https://secure.gravatar.com/avatar/fb37773c631ed56f8118034696f9f2e4?s=24&d=mm&r=g",
            "48": "https://secure.gravatar.com/avatar/fb37773c631ed56f8118034696f9f2e4?s=48&d=mm&r=g",
            "96": "https://secure.gravatar.com/avatar/fb37773c631ed56f8118034696f9f2e4?s=96&d=mm&r=g"
          },
          "_links": {
            "self": [
              {
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/users/1"
              }
            ],
            "collection": [
              {
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/users"
              }
            ]
          }
        }
      ],
      "wp:featuredmedia": [
        {
          "id": 22,
          "date": "2023-10-04T22:26:57",
          "slug": "front-view-man-with-wooden-blocks",
          "type": "attachment",
          "link": "https://rlimaadv.com.br/blog/a-importancia-da-esg-rumo-a-um-futuro-sustentavel-no-brasil/front-view-man-with-wooden-blocks/",
          "title": {
            "rendered": "front-view-man-with-wooden-blocks"
          },
          "author": 1,
          "caption": {
            "rendered": ""
          },
          "alt_text": "",
          "media_type": "image",
          "mime_type": "image/jpeg",
          "media_details": {
            "width": 2560,
            "height": 1707,
            "file": "2023/10/front-view-man-with-wooden-blocks-scaled.jpg",
            "filesize": 305049,
            "sizes": {
              "medium": {
                "file": "front-view-man-with-wooden-blocks-300x200.jpg",
                "width": 300,
                "height": 200,
                "filesize": 12648,
                "mime_type": "image/jpeg",
                "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/front-view-man-with-wooden-blocks-300x200.jpg"
              },
              "large": {
                "file": "front-view-man-with-wooden-blocks-1024x683.jpg",
                "width": 1024,
                "height": 683,
                "filesize": 74479,
                "mime_type": "image/jpeg",
                "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/front-view-man-with-wooden-blocks-1024x683.jpg"
              },
              "thumbnail": {
                "file": "front-view-man-with-wooden-blocks-150x150.jpg",
                "width": 150,
                "height": 150,
                "filesize": 5974,
                "mime_type": "image/jpeg",
                "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/front-view-man-with-wooden-blocks-150x150.jpg"
              },
              "medium_large": {
                "file": "front-view-man-with-wooden-blocks-768x512.jpg",
                "width": 768,
                "height": 512,
                "filesize": 48379,
                "mime_type": "image/jpeg",
                "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/front-view-man-with-wooden-blocks-768x512.jpg"
              },
              "1536x1536": {
                "file": "front-view-man-with-wooden-blocks-1536x1024.jpg",
                "width": 1536,
                "height": 1024,
                "filesize": 135711,
                "mime_type": "image/jpeg",
                "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/front-view-man-with-wooden-blocks-1536x1024.jpg"
              },
              "2048x2048": {
                "file": "front-view-man-with-wooden-blocks-2048x1365.jpg",
                "width": 2048,
                "height": 1365,
                "filesize": 213482,
                "mime_type": "image/jpeg",
                "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/front-view-man-with-wooden-blocks-2048x1365.jpg"
              },
              "full": {
                "file": "front-view-man-with-wooden-blocks-scaled.jpg",
                "width": 2560,
                "height": 1707,
                "mime_type": "image/jpeg",
                "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/front-view-man-with-wooden-blocks-scaled.jpg"
              }
            },
            "image_meta": {
              "aperture": "8",
              "credit": "",
              "camera": "Canon EOS RP",
              "caption": "",
              "created_timestamp": "1675196320",
              "copyright": "",
              "focal_length": "100",
              "iso": "100",
              "shutter_speed": "0.008",
              "title": "",
              "orientation": "1",
              "keywords": []
            },
            "original_image": "front-view-man-with-wooden-blocks.jpg"
          },
          "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/front-view-man-with-wooden-blocks-scaled.jpg",
          "_links": {
            "self": [
              {
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/media/22"
              }
            ],
            "collection": [
              {
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/media"
              }
            ],
            "about": [
              {
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/types/attachment"
              }
            ],
            "author": [
              {
                "embeddable": true,
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/users/1"
              }
            ],
            "replies": [
              {
                "embeddable": true,
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/comments?post=22"
              }
            ]
          }
        }
      ],
      "wp:term": [
        [
          {
            "id": 1,
            "link": "https://rlimaadv.com.br/blog/category/uncategorized/",
            "name": "Uncategorized",
            "slug": "uncategorized",
            "taxonomy": "category",
            "_links": {
              "self": [
                {
                  "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/categories/1"
                }
              ],
              "collection": [
                {
                  "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/categories"
                }
              ],
              "about": [
                {
                  "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/taxonomies/category"
                }
              ],
              "wp:post_type": [
                {
                  "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/posts?categories=1"
                }
              ],
              "curies": [
                {
                  "name": "wp",
                  "href": "https://api.w.org/{rel}",
                  "templated": true
                }
              ]
            }
          }
        ],
        []
      ]
    }
  },
  {
    "id": 10,
    "date": "2023-10-03T18:11:17",
    "date_gmt": "2023-10-03T21:11:17",
    "guid": {
      "rendered": "https://rlimaadv.com.br/blog/?p=10"
    },
    "modified": "2023-10-03T18:42:10",
    "modified_gmt": "2023-10-03T21:42:10",
    "slug": "compliance-esg",
    "status": "publish",
    "type": "post",
    "link": "https://rlimaadv.com.br/blog/compliance-esg/",
    "title": {
      "rendered": "Compliance ESG"
    },
    "content": {
      "rendered": "\n<figure class=\"wp-block-image size-large\"><img decoding=\"async\" loading=\"lazy\" width=\"1024\" height=\"683\" src=\"https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/esg-1024x683.jpg\" alt=\"\" class=\"wp-image-12\" srcset=\"https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/esg-1024x683.jpg 1024w, https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/esg-300x200.jpg 300w, https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/esg-768x513.jpg 768w, https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/esg.jpg 1500w\" sizes=\"(max-width: 1024px) 100vw, 1024px\" /></figure>\n\n\n\n<p>ESG é a sigla em inglês para Ambiental, Social e Governança. Na prática, é uma análise holística dos indicadores de desempenho do negócio para além das questões financeiras.<strong> </strong>Essas três letrinhas você já deve ter ouvido falar, imagino que deve ter se perguntado do que se trata. ESG é a sigla para Ambiental, Social e Governança em inglês (Environmental, Social and Governance).</p>\n\n\n\n<p>Fortemente influenciada pela experiência na bolsa de valores, a sigla revela a demanda global por negócios mais responsáveis, éticos e transparentes, o famoso dever de prestar contas ou <em>accountability </em>dos negócios para a sociedade, clientes, investidores e o Planeta.&nbsp;</p>\n\n\n\n<p>Assim, no lugar de medirmos se um negócio vai bem apenas olhando para o lucro ou informações financeiras, passamos a medir o desempenho com base em indicadores que contemplem as três áreas.</p>\n\n\n\n<p>É sobre ser responsável e demonstrar as melhores práticas através de indicadores e metas verificáveis, afinal de contas, hoje mais do que nunca, vemos a necessidade em materializar o discurso da sustentabilidade para que não fique apenas no blá blá blá. &nbsp;Através dessa análise é possível compreender quais os pontos de atenção e em quais áreas o negócio melhor desempenha. &nbsp;A moldura para definição dos indicadores vai depender das características do negócio ou setor, porém trazemos aqui alguns exemplos de indicadores nos 3 eixos:&nbsp;</p>\n\n\n\n<p><strong>A</strong>mbiental &gt;&gt; consumo de água, consumo de energia elétrica, gases de efeito estufa, reciclagem, qualidade do ar, eficiência energética de aparelhos.</p>\n\n\n\n<p><strong>S</strong>ocial &gt;&gt; número de novas vagas,&nbsp; rotatividade de trabalhadores, pesquisa demográfica, diversidade e inclusão social.</p>\n\n\n\n<p><strong>G</strong>overnança &gt;&gt;&nbsp; Relatórios de impacto, Análise de materialidade de impactos, mapeamento de partes interessadas, diagnóstico da organização, forma de gestão, compliance.&nbsp;</p>\n\n\n\n<p>Através de uma avaliação geral da organização poderemos monitorar e estabelecer metas nos 3 eixos para entender quão bem o negócio está desempenhando, além de estabelecer os caminhos que podemos traçar para alcançar os objetivos desejados.</p>\n\n\n\n<p>Como resultado desse esforço, percebemos alguns benefícios como diminuição de custos, maior eficiência socioambiental, trabalhadores engajados, clientes que apoiam e defendem a sua marca, tornar-se referência de mercado e inclusive o aumento da receita pela gestão inteligente e otimizada dos recursos, além de aumentar a resiliência da empresa o que é fundamental frente aos desafios do nosso tempo.</p>\n\n\n\n<p></p>\n\n\n\n<p><strong>Bruna Albuquerque é advogada especialista em Gestão Ambiental. Consultora em sustentabilidade e triplo impacto positivo. Agente de soluções que geram impactos positivos.</strong></p>\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "<p>ESG é a sigla em inglês para Ambiental, Social e Governança. Na prática, é uma análise holística dos indicadores de desempenho do negócio para além das questões financeiras. Essas três letrinhas você já deve ter ouvido falar, imagino que deve ter se perguntado do que se trata. ESG é a sigla para Ambiental, Social e [&hellip;]</p>\n",
      "protected": false
    },
    "author": 1,
    "featured_media": 12,
    "comment_status": "open",
    "ping_status": "open",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "footnotes": ""
    },
    "categories": [
      1
    ],
    "tags": [],
    "better_featured_image": {
      "id": 12,
      "alt_text": "",
      "caption": "",
      "description": "",
      "media_type": "image",
      "media_details": {
        "width": 1500,
        "height": 1001,
        "file": "2023/10/esg.jpg",
        "filesize": 430690,
        "sizes": {
          "medium": {
            "file": "esg-300x200.jpg",
            "width": 300,
            "height": 200,
            "mime-type": "image/jpeg",
            "filesize": 14616,
            "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/esg-300x200.jpg"
          },
          "large": {
            "file": "esg-1024x683.jpg",
            "width": 1024,
            "height": 683,
            "mime-type": "image/jpeg",
            "filesize": 108867,
            "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/esg-1024x683.jpg"
          },
          "thumbnail": {
            "file": "esg-150x150.jpg",
            "width": 150,
            "height": 150,
            "mime-type": "image/jpeg",
            "filesize": 7280,
            "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/esg-150x150.jpg"
          },
          "medium_large": {
            "file": "esg-768x513.jpg",
            "width": 768,
            "height": 513,
            "mime-type": "image/jpeg",
            "filesize": 69560,
            "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/esg-768x513.jpg"
          }
        },
        "image_meta": {
          "aperture": "0",
          "credit": "Shutterstock",
          "camera": "",
          "caption": "",
          "created_timestamp": "0",
          "copyright": "Copyright (c) 2021 Juicy FOTO/Shutterstock.  No use without permission.",
          "focal_length": "0",
          "iso": "0",
          "shutter_speed": "0",
          "title": "Hands,Holding,The,Green,Ball,That,Writes,The,Word,Esg",
          "orientation": "1",
          "keywords": [
            "standard,symbol,screening,criteria,organisation,pollution,eco,green factory,manufacturing,businessman,energy,ecological,environmental,natural,resource,investment,economy,sustainability,conservation,ethic,renewable,header,sustainable,idea,icon,global,pictogram,ecology,outline,world,responsibility,company,hand,green,business,nature,social,ethical,environment,money,management,earth,organization,esg,report,illustration,risk,strategy,finance,governance"
          ]
        }
      },
      "post": 10,
      "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/esg.jpg"
    },
    "_links": {
      "self": [
        {
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/posts/10"
        }
      ],
      "collection": [
        {
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/users/1"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/comments?post=10"
        }
      ],
      "version-history": [
        {
          "count": 2,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/posts/10/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 13,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/posts/10/revisions/13"
        }
      ],
      "wp:featuredmedia": [
        {
          "embeddable": true,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/media/12"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/media?parent=10"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/categories?post=10"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/tags?post=10"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    },
    "_embedded": {
      "author": [
        {
          "id": 1,
          "name": "rlima_admin",
          "url": "https://rlimaadv.com.br/blog",
          "description": "",
          "link": "https://rlimaadv.com.br/blog/author/rlima_admin/",
          "slug": "rlima_admin",
          "avatar_urls": {
            "24": "https://secure.gravatar.com/avatar/fb37773c631ed56f8118034696f9f2e4?s=24&d=mm&r=g",
            "48": "https://secure.gravatar.com/avatar/fb37773c631ed56f8118034696f9f2e4?s=48&d=mm&r=g",
            "96": "https://secure.gravatar.com/avatar/fb37773c631ed56f8118034696f9f2e4?s=96&d=mm&r=g"
          },
          "_links": {
            "self": [
              {
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/users/1"
              }
            ],
            "collection": [
              {
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/users"
              }
            ]
          }
        }
      ],
      "wp:featuredmedia": [
        {
          "id": 12,
          "date": "2023-10-03T18:41:31",
          "slug": "handsholdingthegreenballthatwritesthewordesg",
          "type": "attachment",
          "link": "https://rlimaadv.com.br/blog/compliance-esg/handsholdingthegreenballthatwritesthewordesg/",
          "title": {
            "rendered": "Hands,Holding,The,Green,Ball,That,Writes,The,Word,Esg"
          },
          "author": 1,
          "caption": {
            "rendered": ""
          },
          "alt_text": "",
          "media_type": "image",
          "mime_type": "image/jpeg",
          "media_details": {
            "width": 1500,
            "height": 1001,
            "file": "2023/10/esg.jpg",
            "filesize": 430690,
            "sizes": {
              "medium": {
                "file": "esg-300x200.jpg",
                "width": 300,
                "height": 200,
                "filesize": 14616,
                "mime_type": "image/jpeg",
                "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/esg-300x200.jpg"
              },
              "large": {
                "file": "esg-1024x683.jpg",
                "width": 1024,
                "height": 683,
                "filesize": 108867,
                "mime_type": "image/jpeg",
                "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/esg-1024x683.jpg"
              },
              "thumbnail": {
                "file": "esg-150x150.jpg",
                "width": 150,
                "height": 150,
                "filesize": 7280,
                "mime_type": "image/jpeg",
                "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/esg-150x150.jpg"
              },
              "medium_large": {
                "file": "esg-768x513.jpg",
                "width": 768,
                "height": 513,
                "filesize": 69560,
                "mime_type": "image/jpeg",
                "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/esg-768x513.jpg"
              },
              "full": {
                "file": "esg.jpg",
                "width": 1500,
                "height": 1001,
                "mime_type": "image/jpeg",
                "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/esg.jpg"
              }
            },
            "image_meta": {
              "aperture": "0",
              "credit": "Shutterstock",
              "camera": "",
              "caption": "",
              "created_timestamp": "0",
              "copyright": "Copyright (c) 2021 Juicy FOTO/Shutterstock.  No use without permission.",
              "focal_length": "0",
              "iso": "0",
              "shutter_speed": "0",
              "title": "Hands,Holding,The,Green,Ball,That,Writes,The,Word,Esg",
              "orientation": "1",
              "keywords": [
                "standard,symbol,screening,criteria,organisation,pollution,eco,green factory,manufacturing,businessman,energy,ecological,environmental,natural,resource,investment,economy,sustainability,conservation,ethic,renewable,header,sustainable,idea,icon,global,pictogram,ecology,outline,world,responsibility,company,hand,green,business,nature,social,ethical,environment,money,management,earth,organization,esg,report,illustration,risk,strategy,finance,governance"
              ]
            }
          },
          "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/esg.jpg",
          "_links": {
            "self": [
              {
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/media/12"
              }
            ],
            "collection": [
              {
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/media"
              }
            ],
            "about": [
              {
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/types/attachment"
              }
            ],
            "author": [
              {
                "embeddable": true,
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/users/1"
              }
            ],
            "replies": [
              {
                "embeddable": true,
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/comments?post=12"
              }
            ]
          }
        }
      ],
      "wp:term": [
        [
          {
            "id": 1,
            "link": "https://rlimaadv.com.br/blog/category/uncategorized/",
            "name": "Uncategorized",
            "slug": "uncategorized",
            "taxonomy": "category",
            "_links": {
              "self": [
                {
                  "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/categories/1"
                }
              ],
              "collection": [
                {
                  "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/categories"
                }
              ],
              "about": [
                {
                  "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/taxonomies/category"
                }
              ],
              "wp:post_type": [
                {
                  "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/posts?categories=1"
                }
              ],
              "curies": [
                {
                  "name": "wp",
                  "href": "https://api.w.org/{rel}",
                  "templated": true
                }
              ]
            }
          }
        ],
        []
      ]
    }
  },
  {
    "id": 6,
    "date": "2023-10-03T17:46:02",
    "date_gmt": "2023-10-03T20:46:02",
    "guid": {
      "rendered": "https://rlimaadv.com.br/blog/?p=6"
    },
    "modified": "2023-10-03T18:44:50",
    "modified_gmt": "2023-10-03T21:44:50",
    "slug": "investimento-de-impacto-o-acesso-a-investidores-ja-e-uma-realidade-para-os-negocios-de-impacto-brasileiros",
    "status": "publish",
    "type": "post",
    "link": "https://rlimaadv.com.br/blog/investimento-de-impacto-o-acesso-a-investidores-ja-e-uma-realidade-para-os-negocios-de-impacto-brasileiros/",
    "title": {
      "rendered": "Investimento de impacto: o acesso a investidores já é uma realidade para os negócios de impacto brasileiros?"
    },
    "content": {
      "rendered": "\n<p><strong>O acesso a investidores para negócios de impacto socioambiental já é uma realidade e tem ganhado destaque nos últimos anos. Todavia, apesar do crescente acesso a investidores, ainda são comuns os desafios e limitações para os negócios de impacto, os quais precisam se adaptar as exigências do mercado de investimento.</strong></p>\n\n\n\n<figure class=\"wp-block-image size-large\"><img decoding=\"async\" loading=\"lazy\" width=\"1024\" height=\"738\" src=\"https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-1024x738.jpg\" alt=\"\" class=\"wp-image-16\" srcset=\"https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-1024x738.jpg 1024w, https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-300x216.jpg 300w, https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-768x554.jpg 768w, https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-1536x1107.jpg 1536w, https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-2048x1476.jpg 2048w\" sizes=\"(max-width: 1024px) 100vw, 1024px\" /></figure>\n\n\n\n<p><strong>1.</strong> &nbsp; <strong>Os Investimentos de Impacto no Brasil</strong></p>\n\n\n\n<p>De acordo com a Global Impact Invest Network (GIIN), os investimentos de impacto desafiam a antiga visão de que: (i) questões sociais e ambientais devem ser endereçadas apenas por doações filantrópicas; e (ii) investimentos de mercado deveriam focar exclusivamente em atingir retorno financeiro. Ao quebrar o referido paradoxo, o mercado dos investimentos de impacto oferece inúmeras oportunidades para investidores contribuírem com o avanço de soluções socioambientais positivas, sem precisar renunciar ao retorno financeiro almejado tradicionalmente.&nbsp;</p>\n\n\n\n<p>O que define um investimento como sendo um “Investimento de Impacto” é o seu objetivo, ou seja, a clara intenção de transformar uma realidade promovendo o impacto social e/ou ambiental através de um negócio de impacto, sem abrir mão, contudo, da obtenção de retorno financeiro sobre o capital investido.&nbsp;</p>\n\n\n\n<p>Nasce assim o desafio primordial de um investimento cujo objetivo é gerar impacto social e/ou ambiental positivo, qual seja, a definição de métricas de impacto precisas e condizentes com a tese investida, sem que tal feito comprometa os retornos financeiros do investimento.</p>\n\n\n\n<p>No Brasil, o volume de investimentos de impacto socioambiental chegou a 18,7 bilhões em 2021, resultado expressivo que representa um crescimento de 60% em relação ao ano anterior de 2020, onde se pode observar um total investido de R$ 11,5% bilhões segundo relatório de investimentos de impacto no brasil divulgado pela Ande (Aspen Network of Development Emtrepreneurs).</p>\n\n\n\n<p>Dentre os principais fatores para tal crescente, tem-se a resposta dos investidores às consequências da pandemia de Covid-19, as quais extrapolam o âmbito da saúde pública, refletindo também em temas como pobreza e desigualdade, trabalho decente e educação.&nbsp;</p>\n\n\n\n<p>Se antes apenas era possível ver um número expressivo de investimentos realizados na área de meio ambiente e alterações climáticas, hoje é possível constatar um aumento na variedade das teses de investimento, muitas delas levando em consideração os 17 objetivos de desenvolvimento sustentável da ONU (ODS).&nbsp;</p>\n\n\n\n<p><strong>2. Diversidade no Acesso aos Investimentos de Impacto</strong></p>\n\n\n\n<p>Diante do crescente aumento de valores investidos em tentativas de mudanças socioambientais positivas, também é possível verificar o aumento na diversidade de formas de acesso a tais investidores. Nesse contexto, alguns dos canais mais comuns incluem:</p>\n\n\n\n<ul>\n<li><strong>Investidores de impacto (investidores anjos):</strong> São investidores que buscam investir em empresas ou projetos que tenham um impacto social ou ambiental positivo. Eles estão dispostos a alocar capital em negócios que alinhem seus objetivos financeiros com o propósito de gerar transformação social e/ou ambiental.</li>\n\n\n\n<li><strong>Fundos de investimento de impacto:</strong> São fundos que se dedicam a investir parcialmente ou exclusivamente em negócios de impacto. Esses fundos reúnem capital de diversos investidores e o direcionam para empresas que estejam alinhadas com os critérios de impacto social e ambiental estabelecidos pelo fundo.</li>\n\n\n\n<li><strong>Plataformas de financiamento coletivo (crowdfunding):</strong> São plataformas online que conectam empreendedores a um grande número de pessoas dispostas a investir em seus projetos.&nbsp;</li>\n\n\n\n<li><strong>Aceleradoras e incubadoras:</strong> São organizações que oferecem apoio e orientação para o desenvolvimento de negócios em estágios iniciais. Muitas vezes, essas organizações têm parcerias com investidores e podem facilitar a conexão entre os empreendedores de negócios de impacto e potenciais investidores.</li>\n</ul>\n\n\n\n<p>Verifica-se, desse modo, uma grande variedade de fontes de investimentos, bem como, um crescente aumento na variedade de teses e níveis de investimentos de impacto, os quais tornam clara a tendência de mercado em priorizar negócios de impacto socioambiental positivo.&nbsp;</p>\n\n\n\n<p><strong>3. Principais Desafios no Acesso ao Investimento de Impacto&nbsp;</strong></p>\n\n\n\n<p>Apesar da expansão dos investimentos de impacto, materializados em números animadores, muitos ainda são os desafios enfrentados pelos empreendedores sociais na busca por esse tipo de financiamento.</p>\n\n\n\n<p>Dentre os principais desafios o principal está na medição e avaliação de impacto. Os Investidores de impacto devem buscar evidências claras do impacto social ou ambiental gerado positivamente pelos negócios.&nbsp; Medir e avaliar o impacto de forma objetiva e confiável pode ser complexo e exigir recursos significativos. Os empreendedores precisam desenvolver metodologias de medição robustos para demonstrar o impacto de suas atividades, o que, por vezes, torna a busca pelo investimento um desafio complexo.</p>\n\n\n\n<p>Nesse contexto também se figura como desafio a conexão sinérgica entre Investidor e Investido, uma vez que para além do retorno financeiro, a missão de gerar impacto socioambiental positivo deverá ser sempre a prioridade de ambas as partes. Assim, encontrar Investidores sinérgicos com a tese de impacto do empreendedor e alinhar as expectativas em relação a esses dois pilares é um desafio que precisa ser enfrentado.</p>\n\n\n\n<p>Muitos investidores ainda estão em processo de aprendizado sobre investimentos de impacto. Alguns podem não estar familiarizados com o conceito ou entender completamente como avaliar oportunidades de investimento de impacto. Isso pode dificultar a busca por investidores que estejam dispostos a apoiar negócios de impacto, motivo pelo qual a carência de conhecimento técnico e consciência de como fomentar de maneira eficaz o impacto socioambiental positivo também se mostra como espectro a ser enfrentado na construção de uma relação sustentável entre os empreendimentos e o investidor.</p>\n\n\n\n<p>Diante de tais fatores e apesar do forte crescimento dos Investimentos de Impacto, alguns investidores ainda consideram negócios de impacto como investimentos de maior risco devido à sua natureza social ou ambiental. Isso pode resultar em maiores exigências em termos de retornos financeiros ou prazos mais curtos para o alcance da sustentabilidade financeira.&nbsp;</p>\n\n\n\n<p>Assim, convencer os investidores de que o risco é gerenciável e que o negócio pode ter um impacto positivo e sustentável, sem comprometer o retorno financeiro ainda é o principal desafio a ser superado.&nbsp;</p>\n\n\n\n<p><strong>Conclusão</strong></p>\n\n\n\n<p>Resta inconteste o crescimento no acesso a investidores de impacto, o que vem se refletindo em dados que demonstram a consolidação da sustentabilidade como arcabouço central das relações negociais através de uma perspectiva de busca por impacto socioambiental positivo.&nbsp;</p>\n\n\n\n<p>Todavia, desafios e limitações para que os negócios de impacto acessem tais investimentos são comuns e fazem parte do desenvolvimento do mercado de impacto e do amadurecimento tanto dos investidores como dos próprios negócios.&nbsp;&nbsp;</p>\n\n\n\n<p>Para superar esses desafios, é importante que os empreendedores de negócios de impacto busquem orientação adequada, construam redes de apoio, aprimorem suas habilidades de comunicação e busquem parcerias estratégicas com organizações e investidores que estejam alinhados com seus valores e objetivos.</p>\n\n\n\n<p><strong>Rafael Lima</strong></p>\n\n\n\n<p>Fundador do R.Lima Advogados e Cofundador da Pontéia. Advogado e empreendedor social, especializado na estruturação de negócios de impacto e organizações da sociedade civil. Também é Professor, Palestrante e Mentor de intermediadoras em todo o Brasil como a Fundação Dom Cabral, Civi-co (SP), Inovativa (SP), Garagem BNDES (SP), Fa.vela (MG), Hub Social (SC), Porto Social (PE), dentre outros.</p>\n\n\n\n<p><a href=\"https://instagram.com/rafacbf\">https://instagram.com/rafacbf</a></p>\n\n\n\n<p><a href=\"https://www.facebook.com/rafaellima.adv\">https://www.facebook.com/rafaellima.adv</a></p>\n\n\n\n<p><a href=\"https://www.linkedin.com/in/rafael-lima-adv/\">https://www.linkedin.com/in/rafael-lima-adv/</a></p>\n\n\n\n<p><a href=\"https://www.youtube.com/\">https://www.youtube.com/</a></p>\n",
      "protected": false
    },
    "excerpt": {
      "rendered": "<p>O acesso a investidores para negócios de impacto socioambiental já é uma realidade e tem ganhado destaque nos últimos anos. Todavia, apesar do crescente acesso a investidores, ainda são comuns os desafios e limitações para os negócios de impacto, os quais precisam se adaptar as exigências do mercado de investimento. 1. &nbsp; Os Investimentos de [&hellip;]</p>\n",
      "protected": false
    },
    "author": 1,
    "featured_media": 16,
    "comment_status": "open",
    "ping_status": "open",
    "sticky": false,
    "template": "",
    "format": "standard",
    "meta": {
      "footnotes": ""
    },
    "categories": [
      1
    ],
    "tags": [],
    "better_featured_image": {
      "id": 16,
      "alt_text": "",
      "caption": "",
      "description": "",
      "media_type": "image",
      "media_details": {
        "width": 2560,
        "height": 1845,
        "file": "2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-scaled.jpg",
        "filesize": 399751,
        "sizes": {
          "medium": {
            "file": "pessoas-de-alto-angulo-juntando-as-maos-1-300x216.jpg",
            "width": 300,
            "height": 216,
            "mime-type": "image/jpeg",
            "filesize": 12699,
            "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-300x216.jpg"
          },
          "large": {
            "file": "pessoas-de-alto-angulo-juntando-as-maos-1-1024x738.jpg",
            "width": 1024,
            "height": 738,
            "mime-type": "image/jpeg",
            "filesize": 76758,
            "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-1024x738.jpg"
          },
          "thumbnail": {
            "file": "pessoas-de-alto-angulo-juntando-as-maos-1-150x150.jpg",
            "width": 150,
            "height": 150,
            "mime-type": "image/jpeg",
            "filesize": 6090,
            "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-150x150.jpg"
          },
          "medium_large": {
            "file": "pessoas-de-alto-angulo-juntando-as-maos-1-768x554.jpg",
            "width": 768,
            "height": 554,
            "mime-type": "image/jpeg",
            "filesize": 48876,
            "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-768x554.jpg"
          },
          "1536x1536": {
            "file": "pessoas-de-alto-angulo-juntando-as-maos-1-1536x1107.jpg",
            "width": 1536,
            "height": 1107,
            "mime-type": "image/jpeg",
            "filesize": 150210,
            "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-1536x1107.jpg"
          },
          "2048x2048": {
            "file": "pessoas-de-alto-angulo-juntando-as-maos-1-2048x1476.jpg",
            "width": 2048,
            "height": 1476,
            "mime-type": "image/jpeg",
            "filesize": 255385,
            "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-2048x1476.jpg"
          }
        },
        "image_meta": {
          "aperture": "0",
          "credit": "",
          "camera": "",
          "caption": "",
          "created_timestamp": "0",
          "copyright": "",
          "focal_length": "0",
          "iso": "0",
          "shutter_speed": "0",
          "title": "",
          "orientation": "0",
          "keywords": []
        },
        "original_image": "pessoas-de-alto-angulo-juntando-as-maos-1.jpg"
      },
      "post": 6,
      "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-scaled.jpg"
    },
    "_links": {
      "self": [
        {
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/posts/6"
        }
      ],
      "collection": [
        {
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/posts"
        }
      ],
      "about": [
        {
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/types/post"
        }
      ],
      "author": [
        {
          "embeddable": true,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/users/1"
        }
      ],
      "replies": [
        {
          "embeddable": true,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/comments?post=6"
        }
      ],
      "version-history": [
        {
          "count": 3,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/posts/6/revisions"
        }
      ],
      "predecessor-version": [
        {
          "id": 17,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/posts/6/revisions/17"
        }
      ],
      "wp:featuredmedia": [
        {
          "embeddable": true,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/media/16"
        }
      ],
      "wp:attachment": [
        {
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/media?parent=6"
        }
      ],
      "wp:term": [
        {
          "taxonomy": "category",
          "embeddable": true,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/categories?post=6"
        },
        {
          "taxonomy": "post_tag",
          "embeddable": true,
          "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/tags?post=6"
        }
      ],
      "curies": [
        {
          "name": "wp",
          "href": "https://api.w.org/{rel}",
          "templated": true
        }
      ]
    },
    "_embedded": {
      "author": [
        {
          "id": 1,
          "name": "rlima_admin",
          "url": "https://rlimaadv.com.br/blog",
          "description": "",
          "link": "https://rlimaadv.com.br/blog/author/rlima_admin/",
          "slug": "rlima_admin",
          "avatar_urls": {
            "24": "https://secure.gravatar.com/avatar/fb37773c631ed56f8118034696f9f2e4?s=24&d=mm&r=g",
            "48": "https://secure.gravatar.com/avatar/fb37773c631ed56f8118034696f9f2e4?s=48&d=mm&r=g",
            "96": "https://secure.gravatar.com/avatar/fb37773c631ed56f8118034696f9f2e4?s=96&d=mm&r=g"
          },
          "_links": {
            "self": [
              {
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/users/1"
              }
            ],
            "collection": [
              {
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/users"
              }
            ]
          }
        }
      ],
      "wp:featuredmedia": [
        {
          "id": 16,
          "date": "2023-10-03T18:44:25",
          "slug": "pessoas-de-alto-angulo-juntando-as-maos-1",
          "type": "attachment",
          "link": "https://rlimaadv.com.br/blog/investimento-de-impacto-o-acesso-a-investidores-ja-e-uma-realidade-para-os-negocios-de-impacto-brasileiros/pessoas-de-alto-angulo-juntando-as-maos-1/",
          "title": {
            "rendered": "pessoas-de-alto-angulo-juntando-as-maos-1"
          },
          "author": 1,
          "caption": {
            "rendered": ""
          },
          "alt_text": "",
          "media_type": "image",
          "mime_type": "image/jpeg",
          "media_details": {
            "width": 2560,
            "height": 1845,
            "file": "2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-scaled.jpg",
            "filesize": 399751,
            "sizes": {
              "medium": {
                "file": "pessoas-de-alto-angulo-juntando-as-maos-1-300x216.jpg",
                "width": 300,
                "height": 216,
                "filesize": 12699,
                "mime_type": "image/jpeg",
                "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-300x216.jpg"
              },
              "large": {
                "file": "pessoas-de-alto-angulo-juntando-as-maos-1-1024x738.jpg",
                "width": 1024,
                "height": 738,
                "filesize": 76758,
                "mime_type": "image/jpeg",
                "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-1024x738.jpg"
              },
              "thumbnail": {
                "file": "pessoas-de-alto-angulo-juntando-as-maos-1-150x150.jpg",
                "width": 150,
                "height": 150,
                "filesize": 6090,
                "mime_type": "image/jpeg",
                "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-150x150.jpg"
              },
              "medium_large": {
                "file": "pessoas-de-alto-angulo-juntando-as-maos-1-768x554.jpg",
                "width": 768,
                "height": 554,
                "filesize": 48876,
                "mime_type": "image/jpeg",
                "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-768x554.jpg"
              },
              "1536x1536": {
                "file": "pessoas-de-alto-angulo-juntando-as-maos-1-1536x1107.jpg",
                "width": 1536,
                "height": 1107,
                "filesize": 150210,
                "mime_type": "image/jpeg",
                "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-1536x1107.jpg"
              },
              "2048x2048": {
                "file": "pessoas-de-alto-angulo-juntando-as-maos-1-2048x1476.jpg",
                "width": 2048,
                "height": 1476,
                "filesize": 255385,
                "mime_type": "image/jpeg",
                "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-2048x1476.jpg"
              },
              "full": {
                "file": "pessoas-de-alto-angulo-juntando-as-maos-1-scaled.jpg",
                "width": 2560,
                "height": 1845,
                "mime_type": "image/jpeg",
                "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-scaled.jpg"
              }
            },
            "image_meta": {
              "aperture": "0",
              "credit": "",
              "camera": "",
              "caption": "",
              "created_timestamp": "0",
              "copyright": "",
              "focal_length": "0",
              "iso": "0",
              "shutter_speed": "0",
              "title": "",
              "orientation": "0",
              "keywords": []
            },
            "original_image": "pessoas-de-alto-angulo-juntando-as-maos-1.jpg"
          },
          "source_url": "https://rlimaadv.com.br/blog/wp-content/uploads/2023/10/pessoas-de-alto-angulo-juntando-as-maos-1-scaled.jpg",
          "_links": {
            "self": [
              {
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/media/16"
              }
            ],
            "collection": [
              {
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/media"
              }
            ],
            "about": [
              {
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/types/attachment"
              }
            ],
            "author": [
              {
                "embeddable": true,
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/users/1"
              }
            ],
            "replies": [
              {
                "embeddable": true,
                "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/comments?post=16"
              }
            ]
          }
        }
      ],
      "wp:term": [
        [
          {
            "id": 1,
            "link": "https://rlimaadv.com.br/blog/category/uncategorized/",
            "name": "Uncategorized",
            "slug": "uncategorized",
            "taxonomy": "category",
            "_links": {
              "self": [
                {
                  "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/categories/1"
                }
              ],
              "collection": [
                {
                  "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/categories"
                }
              ],
              "about": [
                {
                  "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/taxonomies/category"
                }
              ],
              "wp:post_type": [
                {
                  "href": "https://rlimaadv.com.br/blog/wp-json/wp/v2/posts?categories=1"
                }
              ],
              "curies": [
                {
                  "name": "wp",
                  "href": "https://api.w.org/{rel}",
                  "templated": true
                }
              ]
            }
          }
        ],
        []
      ]
    }
  },
]
